import { render, staticRenderFns } from "./PosReportBox.vue?vue&type=template&id=e8b7c2d6&scoped=true"
import script from "./PosReportBox.vue?vue&type=script&lang=js"
export * from "./PosReportBox.vue?vue&type=script&lang=js"
import style0 from "./PosReportBox.vue?vue&type=style&index=0&id=e8b7c2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b7c2d6",
  null
  
)

export default component.exports